import { render, staticRenderFns } from "./ValidatePassword.vue?vue&type=template&id=5606cf12&scoped=true&"
import script from "./ValidatePassword.vue?vue&type=script&lang=js&"
export * from "./ValidatePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5606cf12",
  null
  
)

export default component.exports